var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200012 4C0.200012 1.79086 1.99087 0 4.20001 0H12.2C14.4092 0 16.2 1.79086 16.2 4V12C16.2 14.2091 14.4092 16 12.2 16H4.20001C1.99087 16 0.200012 14.2091 0.200012 12V4Z",
    fill: "#7F94B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20066 3.62558C5.4393 3.62558 3.20131 5.4437 3.20131 7.68755C3.20131 8.61712 3.58993 9.46857 4.23438 10.154C3.9434 10.9235 3.33801 11.5757 3.32824 11.5835C3.19936 11.7202 3.1642 11.9194 3.23841 12.0913C3.31262 12.2631 3.48252 12.3744 3.67 12.3744C4.87101 12.3744 5.81816 11.8726 6.38644 11.4703C6.95082 11.648 7.56012 11.7495 8.20066 11.7495C10.962 11.7495 13.2 9.9314 13.2 7.68755C13.2 5.4437 10.962 3.62558 8.20066 3.62558ZM8.20066 10.8121C7.67924 10.8121 7.16369 10.7321 6.66961 10.5759L6.22631 10.4352L5.8455 10.7047C5.56624 10.902 5.18347 11.1227 4.7226 11.2711C4.86516 11.0348 5.00381 10.7692 5.11122 10.486L5.31822 9.93726L4.91593 9.51154C4.56246 9.13463 4.13869 8.51167 4.13869 7.68755C4.13869 5.96512 5.96072 4.56296 8.20066 4.56296C10.4406 4.56296 12.2626 5.96512 12.2626 7.68755C12.2626 9.40999 10.4406 10.8121 8.20066 10.8121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.ef292e7f504faffca14985fcae2bfc12.svg";
export { ForwardRef as ReactComponent };